import AudioPlayer from '../AudioPlayer';

export function showAudioPlayer(audioPlayerEl) {
  if (!audioPlayerEl) return;
  audioPlayerEl.style.display = 'block';
  audioPlayerEl.classList.add('is-visible');
}

export function hideAudioPlayer(audioPlayerEl) {
  if (!audioPlayerEl) return;
  audioPlayerEl.style.display = 'none';
  audioPlayerEl.classList.remove('is-visible');
}

export function setHasPlayer(overlayEl, hasPlayer) {
  if (!overlayEl || !overlayEl.parentNode) return;
  overlayEl.classList.toggle('has-player', !!hasPlayer);
  overlayEl.parentNode.classList.toggle('has-player', !!hasPlayer);
}

export function resetAudioInstance() {
  if (window.audioplayer != null) {
    try {
      AudioPlayer.resetInstance();
      window.audioplayer = null;
    } catch (error) {
      console.error('Error in resetAudioInstance:', error);
    }
  }
}

export function applyPlayerData({ audioPlayerEl, overlayEl, dataEl }) {
  try {
    if (!audioPlayerEl || !dataEl) return;

    const title = dataEl.getAttribute('data-title');
    const cover = dataEl.getAttribute('data-cover');
    const audio = dataEl.getAttribute('data-audio');

    const audioPlayerTitle = audioPlayerEl.querySelector('.js-player-title');
    const audioPlayerCover = audioPlayerEl.querySelector('.js-player-cover');

    if (!audioPlayerTitle || !audioPlayerCover) {
      return;
    }

    showAudioPlayer(audioPlayerEl);

    audioPlayerTitle.textContent = title;
    audioPlayerCover.src = cover;

    if (window.audioplayer) {
      resetAudioInstance();
    }

    window.audioplayer = AudioPlayer.getInstance(audio);
    setHasPlayer(overlayEl, true);

    requestAnimationFrame(() => {
      showAudioPlayer(audioPlayerEl);
    });
  } catch (error) {
    console.error('Error in applyPlayerData:', error);
    hideAudioPlayer(audioPlayerEl);
    setHasPlayer(overlayEl, false);
  }
}

